const ccu = {
  FORMS: [
    {
      type: 'ccu-distribucion-form',
      name: 'CCUDistribucionForm',
      message: {
        open: 'Opción Distribución',
        send: 'Envío Formulario Distribución'
      }
    },
    {
      type: 'ccu-reclamo-form',
      name: 'CCUReclamoForm',
      message: {
        open: 'Opción Reclamo',
        send: 'Envío Formulario Reclamo'
      }
    },
    {
      type: 'ccu-reclamo-camion-form',
      name: 'CCUReclamoCamionForm',
      message: {
        open: 'Opción Reclamo Camion',
        send: 'Envío Formulario Reclamo Camion'
      }
    },
    {
      type: 'ccu-camion-otros-form',
      name: 'CCUFormularioOtros',
      message: {
        open: 'Opción otros camión',
        send: 'Envío Formulario Otros'
      }
    },
    {
      type: 'ccu-camion-otros-supplier-form',
      name: 'CCUFormularioOtros',
      message: {
        open: 'Opción otros Proveedor',
        send: 'Envío Formulario Proveedor'
      }
    },
    {
      type: 'ccu-camion-otros-donation-form',
      name: 'CCUFormularioOtros',
      message: {
        open: 'Opción otros Donación',
        send: 'Envío Formulario Donación'
      }
    },
    {
      type: 'ccu-camion-otros-auspice-form',
      name: 'CCUFormularioOtros',
      message: {
        open: 'Opción otros Auspicio',
        send: 'Envío Formulario Auspicio'
      }
    },
    {
      type: 'ccu-creccu-form',
      name: 'CCUFormCRECCU',
      message: {
        open: 'Opción otros',
        send: 'Envío Formulario CRECCU'
      }
    },
    {
      type: 'ccu-reclamo-otros-form',
      name: 'CCUReclamoOtrosForm',
      message: {
        open: 'Opción Reclamo Otros',
        send: 'Envío Formulario Reclamo Otros'
      }
    },
    {
      type: 'ccu-reclamo-otros-form-confirm',
      name: 'CCUReclamoOtrosForm',
      message: {
        open: 'Opción Reclamo Otros',
        send: 'Envío Formulario Reclamo Otros'
      }
    },
    {
      type: 'ccu-reclamo-otros-form-labarra',
      name: 'CCUReclamoOtrosForm',
      message: {
        open: 'Opción Reclamo La Barra',
        send: 'Envío Formulario La Barra'
      }
    },
    {
      type: 'ccu-reclamo-otros-form-maquina',
      name: 'CCUReclamoOtrosForm',
      message: {
        open: 'Opción Reclamo Máquina Vending',
        send: 'Envío Formulario Máquina Vending'
      }
    },
    {
      type: 'ccu-reclamo-otros-form-cliente',
      name: 'CCUReclamoOtrosForm',
      message: {
        open: 'Opción Reclamo Cliente',
        send: 'Envío Formulario Cliente'
      }
    },
    {
      type: 'ccu-reclamo-otros-form-cliente-confirm',
      name: 'CCUReclamoOtrosForm',
      message: {
        open: 'Opción Reclamo Otros',
        send: 'Envío Formulario Cliente'
      }
    },
    {
      type: 'ccu-reclamo-otros-form-maquina-confirm',
      name: 'CCUReclamoOtrosForm',
      message: {
        open: 'Opción Reclamo Otros',
        send: 'Envío Formulario Máquina Vending'
      }
    },
    {
      type: 'ccu-reclamo-otros-form-labarra-confirm',
      name: 'CCUReclamoOtrosForm',
      message: {
        open: 'Opción Reclamo Otros',
        send: 'Envío Formulario La Barra'
      }
    },
    {
      type: 'ccu-otros-form',
      name: 'CCUOtrosForm',
      message: {
        open: 'Opción Otros',
        send: 'Envío Formulario Otros'
      }
    },
    {
      type: 'ccu-servicio-tecnico-form',
      name: 'CCUServicioTecnicoForm',
      message: {
        open: 'Opción Servicio Técnico',
        send: 'Envío Formulario Servicio Técnico'
      }
    },
    {
      type: 'ccu-camion-otros-form-confirm-supplier',
      name: 'CCUReclamoOtrosForm',
      message: {
        open: 'Opción Otros',
        send: 'Envío Formulario Proveedor'
      }
    },
    {
      type: 'ccu-camion-otros-form-confirm-auspice',
      name: 'CCUReclamoOtrosForm',
      message: {
        open: 'Opción Otros',
        send: 'Envío Formulario Auspicio'
      }
    },
    {
      type: 'ccu-camion-otros-form-confirm-donation',
      name: 'CCUReclamoOtrosForm',
      message: {
        open: 'Opción Otros',
        send: 'Envío Formulario Donación'
      }
    },
    {
      type: 'ccu-ventas-form',
      name: 'CCUVentasForm',
      message: {
        open: 'Opción Ventas',
        send: 'Envío Formulario Ventas'
      }
    }
  ],
  CSS: {
    id: '507f191e810c19729de860ea',
    name: 'ccu',
    avatar: {
      name: 'CCU',
      header: 'https://chatbotqa.gatblac.com/static/avatar/ccu/avatar-reposo.png',
      new: 'https://chatbotqa.gatblac.com/static/avatar/ccu/avatar-inactivo.png',
      open: 'https://chatbotqa.gatblac.com/static/avatar/ccu/avatar-activo.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/ccu/avatar-reposo.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#73ae45',
        borderColor: '#73ae45'
      }
    }
  }
}

export default ccu
